import { keyframes } from '@mui/material';

export const bounceUp = keyframes`
	0% {
		transform: translateY(100vh);
	}
	60% {
		transform: translateY(-10%);
	}
	100% {
		transform: translateY(0);
	}
`;

export const scaleUp = keyframes`
	from {
		transform: scale(0)
	}
	to {
		transform: scale(1)
	}
`;

export const scaleY = keyframes`
	from {
		transform: scaleY(0)
	}
	to {
		transform: scaleY(1)
	}
`;

export const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;
